import { PropsWithChildren } from "react";
import { HttpContext } from "./HttpContext";
import { clientFactory } from "./client";
import { API_TIMEOUT_MS, DASHBOARD_API_PATH, DASHBOARD_API_URL } from "../../utils/environment";
import { useTotpModal } from "@synota-io/synota-shared-ui";
import { ClientTotpModal } from "./ClientTotpModal";

const client = clientFactory({
  baseURL: DASHBOARD_API_URL,
  apiPath: DASHBOARD_API_PATH,
  clientMaxTimeout: API_TIMEOUT_MS,
});

export const HttpProvider = ({ children }: PropsWithChildren) => {
  const totp = useTotpModal();
  return (
    <HttpContext.Provider value={{ client, totp }}>
      {children}
      <ClientTotpModal {...totp} />
    </HttpContext.Provider>
  );
};
